// extracted by mini-css-extract-plugin
export default {"root":"root--6653cd2","row":"row--26cd31b","kitchenware":"kitchenware--68c53b3","delete":"delete--663f0d3","cta":"cta--7c50544"};